import { render, staticRenderFns } from "./GeneralInformationTab.vue?vue&type=template&id=719074df&"
import script from "./GeneralInformationTab.vue?vue&type=script&lang=js&"
export * from "./GeneralInformationTab.vue?vue&type=script&lang=js&"
import style0 from "./GeneralInformationTab.vue?vue&type=style&index=0&id=719074df&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports